module.exports = __webpack_public_path__ + "img/illust2.8705ad87.png";